<div
  [ngClass]="{
    grid: containerWideClass !== '',
    'container--wide': containerWideClass === 'yes'
  }"
>
  <ft-bar-chart
    *ngFor="let chart of data"
    [data]="chart"
    [defaultShowAll]="false"
    [containerWideClass]="containerWideClass"
  ></ft-bar-chart>
</div>
